import { AuthGuard } from './guards/auth.guard';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'osa-treatment',
    loadChildren: () => import('./osa-treatment/osa-treatment.module').then( m => m.OsaTreatmentPageModule)
  },
  {
    path: 'inspire-work',
    loadChildren: () => import('./inspire-work/inspire-work.module').then( m => m.InspireWorkPageModule)
  },
  {
    path: 'clinical-data',
    loadChildren: () => import('./clinical-data/clinical-data.module').then( m => m.ClinicalDataPageModule)
  },
  {
    path: 'qualitification',
    loadChildren: () => import('./qualitification/qualitification.module').then( m => m.QualitificationPageModule)
  },
  {
    path: 'procedure-recovery',
    loadChildren: () => import('./procedure-recovery/procedure-recovery.module').then( m => m.ProcedureRecoveryPageModule)
  },
  {
    path: 'inspire-care',
    loadChildren: () => import('./inspire-care/inspire-care.module').then( m => m.InspireCarePageModule)
  },
  {
    path: 'sleep-apnea',
    loadChildren: () => import('./sleep-apnea/sleep-apnea.module').then( m => m.SleepApneaPageModule)
  },
  {
    path: 'unlock',
    loadChildren: () => import('./unlock/unlock.module').then( m => m.UnlockPageModule)
  },
  {
    path: 'health-risk',
    loadChildren: () => import('./modals/health-risk/health-risk.module').then( m => m.HealthRiskPageModule)
  },
  {
    path: 'scar-photo',
    loadChildren: () => import('./modals/scar-photo/scar-photo.module').then( m => m.ScarPhotoPageModule)
  },
  {
    path: 'safty-info',
    loadChildren: () => import('./modals/safty-info/safty-info.module').then( m => m.SaftyInfoPageModule)
  },
  {
    path: 'intro',
    loadChildren: () => import('./intro/intro.module').then( m => m.IntroPageModule)
  },
  {
    path: 'unlock-tablet',
    loadChildren: () => import('./unlock-tablet/unlock-tablet.module').then( m => m.UnlockTabletPageModule)
  },
  {
    path: 'admin-dash',
    loadChildren: () => import('./admin-dash/admin-dash.module').then( m => m.AdminDashPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
